import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserserviceService } from './userservice.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  loggeduser:any;
  // isstudent:boolean=false;
  // isboardadmin:boolean=false;
  roleid:any;
  apptype: string | null;
    constructor(private router: Router, private service:UserserviceService) {
      this.loggeduser= sessionStorage.getItem('loggeduser');
      this.roleid= sessionStorage.getItem('roleid');
      this.apptype=sessionStorage.getItem('loggedapptype');

      //code to close navbar on  click 
    $(function () {
      // var clickover:any;
      $(document).click(function (event) {
       
      //  checkContrast()
         var clickover = $(event.target);
          //  console.log(clickover);
            var _opened = $("#navbarSupportedContent").hasClass("navbar-collapse navmob justify-content-end collapse show") || $("#navbarSupportedContent").hasClass("navbar-collapse navmob justify-content-end collapse show");
           console.log( _opened);
            if(_opened === true && !clickover.hasClass("navbarbtn") && !clickover.hasClass("nav-link dropdown-toggle") ) {
                $("button.navbarbtn").click();
            }
         
        });
    
      });
    }
    onActivate(event:any) {
      window.scroll({ 
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
      });
     }
    get isstudent(){
      return this.loggeduser && this.roleid === "1";
    }
    get isboardadmin(){
      return this.loggeduser && this.roleid === "2";
    }
    get isboardcord(){
      return this.loggeduser && this.roleid === "3";
    }
    get isfreshmigration(){
      return this.isstudent && this.apptype === "Fresh_Migration_Certificate";
    }
    get isnamechagemarsheet(){
      return this.isstudent && this.apptype === "Change_Request_On_Marksheet";
    }
    get isnamechagepassingcert(){
      return this.isstudent && this.apptype === "Change_Request_On_Passing_Certificate";
    }
    get isduplimigration(){
      return this.isstudent && this.apptype === "Duplicate_Migration_Certificat";
    }
    get isduplicatepassingcertificate(){
      return this.isstudent && this.apptype === "Duplicate_Passing_Certificate";
    }
    get isduplicatemarsheet(){
      return this.isstudent && this.apptype === "Duplicate_Marksheet";
    }
  
   logout(){
    this.service.logout();
    // this.loggeduser="";
  }
}
